import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faQrcode, faMedal, faClockFour, faListUl, faPlay, faPrayingHands, faBookOpen, faPlaceOfWorship, faRoute, faHome, faVideo, faBroadcastTower, faPray, faHandsPraying, faPersonPraying } from '@fortawesome/free-solid-svg-icons';
import './SanatanHome.css';
import sanatanimage from '../../assets/pageimages/Sanatan.webp';


function SanatanHome() {
 const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Income");

  const items = [
    { label: "My Chanting", icon: faPersonPraying, link: "/sanatan-mychanting" },
    { label: "Chant", icon: faPlay, link: "/sanatan-chant" },
    { label: "Puja Vidhi", icon: faPrayingHands, link: "/sanatan-puja-vidhi" },
    { label: "Books", icon: faBookOpen, link: "/sanatan-books" },
    { label: "Religious Places", icon: faPlaceOfWorship, link: "/sanatan-places" },
    { label: "Sanatan Tours", icon: faRoute, link: "/sanatan-tours" },
    { label: "Dharmashalas", icon: faHome, link: "/sanatan-dharmasalas" },
    { label: "Video Library", icon: faVideo, link: "/sanatan-videos" },
    { label: "Live", icon: faBroadcastTower, link: "/sanatan-live" },
    { label: "Shivirs", icon: faPray, link: "/sanatan-shivirs" },
  ];

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-gray-900 border-b border-orange-600 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-yellow-300">🌼🪔 Sanatan Bhakti</div>
          <div className="text-[11px] lg:text-lg text-white">Sanatan - चिर काल तक, हमेशा रहने वाला</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="mt-4 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-2xl text-white"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-orange-600 border-b border-orange-600 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 font-medium">Welcome, {userName}</div>
              <div className="flex gap-3">
                 <button
                  onClick={handleLogout}
                  className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">Login</Link>
            </div>
          )}
        </div>
      )}

      <div className="min-h-[90vh]">
        <div className="flex flex-col justify-center items-center">
          <img id="sanatan-id" src={sanatanimage} alt="Sanatan Image" style={{width: "300px", height:"100%"}}/>
        </div>
        <div className="py-8 px-8 mt-4">
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-3 place-items-center">
            {items.map((item, idx) => (
              <Link
                key={idx}
                to={item.link}
                className="
                  flex flex-col items-center justify-center
                  p-4 w-full rounded-lg no-underline
                  bg-orange-600 text-white shadow-md
                  hover:bg-orange-700 hover:shadow-lg
                  transition-all duration-200
                  focus:outline-none focus:ring-2 
                  focus:ring-orange-500 focus:ring-offset-2 
                  focus:ring-offset-gray-900
                "
              >
                <FontAwesomeIcon icon={item.icon} className="mb-1 text-lg" />
                <span className="text-sm">{item.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <footer className="bg-gray-900 border-t border-orange-600 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm text-white">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-orange-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-orange-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-orange-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-orange-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default SanatanHome;
